module.exports = __webpack_public_path__ + "static/media/crosSvg.1fdc051b.svg";